import { render } from "./InputFormBox.vue?vue&type=template&id=3f3b264e&scoped=true"
import script from "./InputFormBox.vue?vue&type=script&lang=js"
export * from "./InputFormBox.vue?vue&type=script&lang=js"

import "@/Common/Styles/inputFormBox.scss?vue&type=style&index=0&id=3f3b264e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3b264e"]])

export default __exports__